import * as types from '../mutations'
import IngredientService from '@/services/IngredientService'

const state = {
  ingredients: []
}

const getters = {
  ingredients: state => state.ingredients
}

const actions = {
  async loadIngredientList ({ commit }) {
    let ingredients = await IngredientService.loadIngredients()
    commit(types.SET_INGREDIENT_LIST, ingredients)
  }
}

const mutations = {
  [types.SET_INGREDIENT_LIST] (state, ingredients) {
    state.ingredients = ingredients
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
